const DATA_GROUP_NAME_ATTR = 'data-group-name';
export const isAlwaysOpenInsurancePopup = (iataCode) => ['Y7'].includes(iataCode);
export function getInsuranceGroupNameAttr(groupName) {
    if (!groupName) {
        return {};
    }
    return { [DATA_GROUP_NAME_ATTR]: groupName };
}
